import { DashboardCardWrapper, LatestCourseCard } from '@/components/ui'
import { ExamBoards, ICourseDetails, ISchemaThemeDto } from '@/types/firebase'
import React, { memo } from 'react'

interface Props {
  courseDetails: ICourseDetails
  isLoadingSelectedCourse: boolean
  examBoard: ExamBoards
  handleCourseClick: () => void
  handleListSlideThemeClick: (theme: ISchemaThemeDto) => Promise<void>
  useEffortSlideTimePlannedChanger?: boolean
  useThemesListSlide?: boolean
}

export const StudentCourseCard = memo<Props>(
  ({
    courseDetails,
    isLoadingSelectedCourse,
    examBoard,
    handleCourseClick,
    handleListSlideThemeClick,
    useEffortSlideTimePlannedChanger = true,
    useThemesListSlide = true,
  }) => {
    return (
      <DashboardCardWrapper as="li" className="col-span-4">
        <LatestCourseCard
          courseDetails={courseDetails}
          isLoadingSelectedCourse={isLoadingSelectedCourse}
          openCourseBtnProps={{
            onClick: handleCourseClick,
            title: 'Open',
          }}
          handleListSlideThemeClick={handleListSlideThemeClick}
          examBoard={examBoard}
          headerText="Course"
          useThemesListSlide={useThemesListSlide}
          useEffortSlideTimePlannedChanger={useEffortSlideTimePlannedChanger}
          isLoadingLastInteractionCourse={false}
        />
      </DashboardCardWrapper>
    )
  },
  (prevProps, nextProps) => {
    return (
      prevProps.courseDetails.course.id === nextProps.courseDetails.course.id &&
      prevProps.isLoadingSelectedCourse === nextProps.isLoadingSelectedCourse &&
      prevProps.examBoard === nextProps.examBoard &&
      prevProps.courseDetails.bookedCourse.courseProgress ===
        nextProps.courseDetails.bookedCourse.courseProgress
    )
  },
)

StudentCourseCard.displayName = 'StudentCourseCard'
